// @flow

import PickUpPage from './PickUpPage';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { State } from 'types/redux';
import type { Props } from './PickUpPage';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import {
  setTransportationOption,
  setTransportationInfo,
  setStartTime
} from 'store/reducers/appointment/actions';
import {
  setDropoffAddress,
  setValetComments,
  setDropoffPreference
} from 'store/reducers/appointment/valetDetails/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import {
  getFirstAvailability,
  getAvailableTimesByDates
} from 'store/reducers/availableTimes/actions';

// Selectors
import {
  allowsLoaner,
  getTransportOptions
} from 'store/reducers/apptOptions/selectors';
import {
  getTransportation,
  getStartTime
} from 'store/reducers/appointment/selectors';
import {
  getValetComments,
  getPickupAddress,
  getDropoffAddress,
  getPickupDropoffSame,
  getIsClutchPartialValet,
  getIsDropoffSpecificAddress
} from 'store/reducers/appointment/valetDetails/selectors';
import {
  getCTABanner,
  showProgressBar,
  hideBottomCTA
} from 'store/reducers/optimizelyABTest/selectors';
import { getExternalValetProvider } from 'store/reducers/dealerSettings/selectors';
import { getLastTimeslotSelected } from 'store/reducers/userInteractions/selectors';
import { masked } from 'store/reducers/ajaxCall/selectors';
import {
  errorLoadingClutchSlots,
  errorValidatingPickupAddress,
  errorValidatingDropoffAddress,
  errorInvalidPickUpAddress,
  errorInvalidDropOffAddress
} from 'store/reducers/errors/selectors';

import { withRouter } from 'react-router';

const mapStateToProps = (state: State): $Shape<Props> => ({
  allowsLoaner: allowsLoaner(state),
  transportation: getTransportation(state),
  valetComments: getValetComments(state),
  pickupAddress: getPickupAddress(state),
  dropoffAddress: getDropoffAddress(state),
  pickupDropoffSame: getPickupDropoffSame(state),
  dropoffAtDealership: getIsClutchPartialValet(state),
  isDropoffSpecificAddress: getIsDropoffSpecificAddress(state),
  transportations: getTransportOptions(state),
  startTime: getStartTime(state),
  externalValet: getExternalValetProvider(state),
  ctaBanner: getCTABanner(state),
  showProgressBar: showProgressBar(state),
  hideBottomCTA: hideBottomCTA(state),
  lastTimeslotSelected: getLastTimeslotSelected(state),
  masked: masked(state),
  errorPickupAddress: errorValidatingPickupAddress(state),
  errorDropoffAddress: errorValidatingDropoffAddress(state),
  errorClutchFailure: errorLoadingClutchSlots(state),
  errorInvalidPickUpAddress: errorInvalidPickUpAddress(state),
  errorInvalidDropOffAddress: errorInvalidDropOffAddress(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      setTransportationOption,
      setValetComments,
      setTransportationInfo,
      setDropoffPreference,
      setDropoffAddress,
      gtmUserEvent,
      setStartTime,
      getFirstAvailability,
      getAvailableTimesByDates
    }
  )
)(PickUpPage);



// WEBPACK FOOTER //
// ./src/components/pages/PickUpPage/PickUpPageContainer.js